import axios from 'axios';

export default {
    getEquipmentList(page, text, sorting) {
        return axios.get('/api/equipment/table',
            {
                params: {
                    page: page,
                    serialNumber: text,
                    sortBy: sorting.sortBy,
                    sortOrder: sorting.sortOrder
                }
            });
    },
    getEquipment(id) {
        return axios.get(`/api/equipment/${id}`);
    },
    saveEquipment(id, equipment) {
        if (id) {
            return axios.put(`/api/equipment/${id}`, equipment);
        }
        return axios.post('/api/equipment', equipment);
    },
    deleteEquipment(id) {
        return axios.delete(`/api/equipment/${id}`);
    },
    download(serialNumber) {
        return axios.download('/api/equipment/export',
            {
                serialNumber: serialNumber
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/equipment/api.js